import { Component, h, Prop } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "@phn/utility/constants";
import { getRightTheme, isDesktop } from "@phn/utility/helper";
import {
  getLogoAriaLabel,
  getLogoLink,
  sendLogoDataLayerEvent,
} from "@phn/utility/logo";
import { navStateStore } from "@phn/state/nav-state-store";
import { ApplicationType } from "../../components";

@Component({
  tag: "phn-logo",
  styleUrl: "logo.scss",
  scoped: true,
})
export class Logo {
  @Prop() size!: string;

  @Prop() app!: ApplicationType;

  @Prop() theme: NavigationThemeType = NavigationTheme.light;

  @Prop() mode: NavigationModeType = NavigationMode.navbar;

  @Prop() breakpoint!: number;

  render(): HTMLPhnLogoElement {
    const { locale } = navStateStore.state;
    const { crest, shop, level0 } = navContentStore.state;

    const logoLink = getLogoLink(locale, this.app, crest, shop);
    const logoAriaLabel = getLogoAriaLabel(locale, this.app, shop, level0);

    return isDesktop(this.breakpoint) ? (
      <phn-p-wordmark
        onClick={() => {
          if (crest) sendLogoDataLayerEvent(crest);
        }}
        href={logoLink}
        aria={crest ? { "aria-label": logoAriaLabel } : undefined}
        size="small"
        theme={getRightTheme(this.theme, this.mode)}
      />
    ) : (
      <phn-p-crest
        onClick={() => {
          if (crest) sendLogoDataLayerEvent(crest);
        }}
        href={logoLink}
        aria={crest ? { "aria-label": logoAriaLabel } : undefined}
      />
    );
  }
}
